var React = require('react');

function InfoIconInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff; opacity:0.2;}.cls-2{fill:#fff;}")),React.createElement("circle",{"className":"cls-1","cx":"12.48","cy":"12.48","r":"11.96","key":1}),React.createElement("path",{"className":"cls-2","d":"M12.5,4.9a1.79,1.79,0,1,1-1.81,1.79A1.79,1.79,0,0,1,12.5,4.9Z","key":2}),React.createElement("path",{"className":"cls-2","d":"M9.81,9.81h4.44V18.7h.88v.88H9.82v-.86h.85v-8H9.81Z","key":3})]);
}

InfoIconInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24.96 24.95"};

module.exports = InfoIconInline;

InfoIconInline.default = InfoIconInline;
